import React, { useState, useEffect, useCallback } from 'react'
import Sidebar from '../../components/sidebar/Sidebar'
import Header from '../../components/headerbar/Header'
import Tab from 'react-bootstrap/Tab'
import Tabs from 'react-bootstrap/Tabs'
import './style.scss'
import axios from 'axios'
import {config} from '../../config'
import moment from 'moment'
import _ from 'lodash'
import { Pagination, Typography } from '@mui/material'
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const statusOptions = [
  {
    id: 1,
    name: 'Pending',
    value: 'pending',
  },
  {
    id: 2,
    name: 'Confirmed',
    value: 'confirmed',
  },
  {
    id: 3,
    name: 'Cancelled',
    value: 'cancelled',
  },
  {
    id: 4,
    name: 'Completed',
    value: 'completed',
  },
]

const Appointments = () => {
  const accesstoken = JSON.parse(localStorage.getItem('user'))
  const [key, setKey] = useState('0')
  const [mobileAppointmentList, setMobileAppointmentList] = useState([])
  const [webAppointmentList, setWebAppointmentList] = useState([])
  const [mobileApptParams, setMobileApptParams] = useState({
    page: 1,
    limit: 10,
    status: 'pending',
  })
  const [mobileApptTotalResult, setMobileApptTotalResult] = useState(0)
  const [mobileApptCurrentPage, setMobileApptCurrentPage] = useState(1)
  const [webApptParams, setWebApptParams] = useState({
    page: 1,
    limit: 10,
    schedule_status: 'pending',
  })
  const [webApptTotalResult, setWebApptTotalResult] = useState(0)
  const [webApptCurrentPage, setWebApptCurrentPage] = useState(1)

  // Get mobile app appointments
  const getMobileAppointments = useCallback(() => {
    axios
      .get(config.apiurl + '/schedule/all-list/list', {
        headers: {
          Authorization: 'Bearer ' + accesstoken.data.access_token,
        },
        params: { ...mobileApptParams },
      })
      .then((res) => {
        if (res?.data?.status?.toLowerCase() === 'true') {
          setMobileAppointmentList(res?.data?.data?.results)
          setMobileApptTotalResult(res?.data?.data?.totalHits)
        }
      })
      .catch((err) => toast(err?.response?.data?.message || err?.response?.data?.error || "Something Went Wrong", { type: "error", }))
  }, [accesstoken.data.access_token, mobileApptParams])
  useEffect(() => {
    key === '0' && getMobileAppointments()
  }, [getMobileAppointments, key, mobileApptParams])

  // Get web appointments
  const getWebAppointments = useCallback(() => {
    axios
      .get(config.apiurl + '/schedules/getappt', {
        headers: {
          Authorization: 'Bearer ' + accesstoken.data.access_token,
        },
        params: { ...webApptParams },
      })
      .then((res) => {
        if (res?.data?.status?.toLowerCase() === 'true') {
          setWebAppointmentList(res?.data?.data)
          setWebApptTotalResult(res?.data?.totalResults)
        }
      })
      .catch((err) => toast(err?.response?.data?.message || err?.response?.data?.error || "Something Went Wrong", { type: "error", }))
  }, [accesstoken.data.access_token, webApptParams])
  useEffect(() => {
    key === '1' && getWebAppointments()
  }, [getWebAppointments, key, webApptParams])

  // Handle Mobile Appointments pagination
  const handleMobileApptPagination = (event, value) => {
    if (typeof value === 'number') {
      setMobileApptCurrentPage(value)
      setMobileApptParams((prevState) => ({ ...prevState, page: value }))
      // setPageQuery({ ...pageQuery, page: value })
    }
  }

  // Handle Web Appointments pagination
  const handleWebApptPagination = (event, value) => {
    if (typeof value === 'number') {
      setWebApptCurrentPage(value)
      setWebApptParams((prevState) => ({ ...prevState, page: value }))
      // setPageQuery({ ...pageQuery, page: value })
    }
  }

  return (
    <>
      <div className="min-height-300 bg-primary position-absolute w-100"></div>
      <Sidebar />
      <main className="main-content position-relative border-radius-lg ">
        <Header />
        <div className="container-fluid py-4">
          <div className="row">
            <div className="col-md-12">
              <div className="card mb-4">
                {' '}
                <div className="card-header pb-3">
                  <div className="row">
                    <div className="col-6 d-flex align-items-center">
                      <h6 className="mb-0">Appointments</h6>
                    </div>
                  </div>
                </div>
                <section>
                  <Tabs
                    id="controlled-tab-example"
                    activeKey={key}
                    onSelect={(k) => setKey(k)}
                    className="mb-3"
                  >
                    {/* Mobile app appointments table */}
                    <Tab eventKey="0" title="Mobile App Appointments">
                      <div className="card-body px-0 pt-0 pb-2">
                        <div className="col-md-3" style={{ paddingInline: 12 }}>
                          <div className="form-group">
                            <label 
                              htmlFor="example-text-input"
                              className="form-control-label"
                            >
                              Status
                            </label>
                            <select
                              className="form-control"
                              name="status"
                              value={mobileApptParams?.status}
                              onChange={(e) =>
                                setMobileApptParams((prevState) => ({
                                  ...prevState,
                                  status: e.target.value,
                                }))
                              }
                            >
                              {statusOptions?.map((data) => (
                                <option value={data?.value} key={data?.id}>
                                  {data?.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                        <div className="table-responsive p-5">
                          <table className="table align-items-center mb-0 ">
                            <thead>
                              <tr>
                                <th className="text-secondary opacity-7 ">
                                  <p>S.No</p>
                                </th>
                                <th className="text-secondary opacity-7">
                                  <p>User Details</p>
                                </th>
                                <th className="text-secondary opacity-7">
                                  <p>Date&Time</p>
                                </th>
                                <th className="text-secondary opacity-7 ">
                                  <p>Product Image</p>
                                </th>
                                <th className="text-secondary opacity-7 ">
                                  <p>Action</p>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {!_.isEmpty(mobileAppointmentList) ? (
                                mobileAppointmentList.map((item, index) => (
                                  <tr key={item._id}>
                                    {/* Sno */}
                                    <td>
                                      <p className="text-xs mb-2">
                                        {mobileApptCurrentPage > 1
                                          ? `${
                                              index + 1 === 10
                                                ? mobileApptCurrentPage
                                                : mobileApptCurrentPage - 1
                                            }${
                                              index + 1 === 10 ? 0 : index + 1
                                            }`
                                          : index + 1}
                                      </p>{' '}
                                    </td>
                                    {/* User details */}
                                    <td>
                                      <div className="d-flex px-2 py-1">
                                        <div className="d-flex flex-column justify-content-center">
                                          <h6 className="mb-1 text-sm ">
                                            Name:&nbsp;{item.user_id?.name}
                                          </h6>
                                          <p className="text-xs mb-2">
                                            Email:&nbsp;{item.user_id?.email}
                                          </p>
                                          <p className="text-xs mb-2">
                                            Mobile:&nbsp;
                                            <span className="text-secondary">
                                              {item.user_id?.phone}
                                            </span>
                                          </p>
                                        </div>
                                      </div>
                                    </td>
                                    {/* date & time */}
                                    <td>
                                      <div className="d-flex px-2 py-1">
                                        <div className="d-flex flex-column justify-content-center">
                                          <h6 className="text-sm mb-2">
                                            <span className="text-dark font-weight-bold ms-sm-2">
                                              status : {item?.schedule_status}
                                            </span>
                                          </h6>
                                          <p className="text-xs mb-2">
                                            <span className="text-dark font-weight-bold ms-sm-2">
                                              {moment(item.date).format(
                                                'DD-MM-YYYY'
                                              )}
                                            </span>
                                          </p>
                                          <p className="text-xs mb-2">
                                            <span className="text-dark font-weight-bold ms-sm-2">
                                              {item.time}
                                            </span>
                                          </p>
                                        </div>
                                      </div>
                                    </td>
                                    {/* Products */}
                                    <td>
                                      <div className="d-flex px-2 py-1">
                                        <div className="d-flex flex-column justify-content-center">
                                          <img
                                            src={
                                              item?.products &&
                                              config?.fileurl +
                                                JSON.parse(item?.products)?.[0]
                                                  ?.image?.[0]?.filename
                                            }
                                            alt="img"
                                            width={40}
                                            height={40}
                                          />
                                        </div>
                                      </div>
                                    </td>
                                    {/* Action */}
                                    <td>
                                      <div className="ms-auto">
                                        <a
                                          href={
                                            '/appointment/mobile/' + item._id
                                          }
                                          className="btn btn-link text-dark px-3 mb-0"
                                        >
                                          <i
                                            className="fa fa-eye text-dark me-2"
                                            aria-hidden="true"
                                          ></i>
                                          View
                                        </a>
                                      </div>
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <>
                                  <tr>
                                    <th
                                      className="text-secondary opacity-7 text-center"
                                      colspan="5"
                                    >
                                      <p>Data not found</p>
                                    </th>
                                  </tr>
                                </>
                              )}
                            </tbody>
                          </table>
                        </div>
                        <div className="col-12 paginationWrapper">
                          {/* Pagination */}
                          {mobileApptTotalResult < 11 ? (
                            <></>
                          ) : (
                            <section className={'paginationWrapper'}>
                              <section>
                                <Typography variant="body1">
                                  Page {mobileApptCurrentPage} of{' '}
                                  {Math.ceil(
                                    mobileApptTotalResult /
                                      mobileApptParams.limit
                                  )}
                                </Typography>
                              </section>
                              <Pagination
                                count={Math.ceil(
                                  mobileApptTotalResult / mobileApptParams.limit
                                )}
                                page={mobileApptCurrentPage}
                                onChange={handleMobileApptPagination}
                                color="primary"
                                shape="rounded"
                              />
                            </section>
                          )}
                        </div>
                      </div>
                    </Tab>

                    {/* Web app appointments table */}
                    <Tab eventKey="1" title="Web Appoinments">
                      <div className="card-body px-0 pt-0 pb-2">
                        <div className="col-md-3" style={{ paddingInline: 12 }}>
                          <div className="form-group">
                            <label
                              htmlFor="example-text-input"
                              className="form-control-label"
                            >
                              Status
                            </label>
                            <select
                              className="form-control"
                              name="status"
                              value={webApptParams?.schedule_status}
                              onChange={(e) =>
                                setWebApptParams((prevState) => ({
                                  ...prevState,
                                  schedule_status: e.target.value,
                                }))
                              }
                            >
                              {statusOptions?.map((data) => (
                                <option value={data?.value} key={data?.id}>
                                  {data?.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                        <div className="table-responsive p-5">
                          <table className="table align-items-center mb-0 ">
                            <thead>
                              <tr>
                                <th className="text-secondary opacity-7 ">
                                  <p>S.No</p>
                                </th>
                                <th className="text-secondary opacity-7">
                                  <p>User Details</p>
                                </th>
                                <th className="text-secondary opacity-7">
                                  <p>Date&Time</p>
                                </th>
                                <th className="text-secondary opacity-7 ">
                                  <p>Product Image</p>
                                </th>
                                <th className="text-secondary opacity-7 ">
                                  <p>Action</p>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {!_.isEmpty(webAppointmentList) ? (
                                webAppointmentList.map((item, index) => (
                                  <tr key={item._id}>
                                    {/* Sno */}
                                    <td>
                                      <p className="text-xs mb-2">
                                        {webApptCurrentPage > 1
                                          ? `${
                                              index + 1 === 10
                                                ? webApptCurrentPage
                                                : webApptCurrentPage - 1
                                            }${
                                              index + 1 === 10 ? 0 : index + 1
                                            }`
                                          : index + 1}
                                      </p>{' '}
                                    </td>
                                    {/* User details */}
                                    <td>
                                      <div className="d-flex px-2 py-1">
                                        <div className="d-flex flex-column justify-content-center">
                                          <h6 className="mb-1 text-sm ">
                                            Name:&nbsp;{item?.name}
                                          </h6>
                                          <p className="text-xs mb-2">
                                            Email:&nbsp;{item?.email}
                                          </p>
                                          <p className="text-xs mb-2">
                                            Mobile:&nbsp;
                                            <span className="text-secondary">
                                              {item?.mobilenum}
                                            </span>
                                          </p>
                                        </div>
                                      </div>
                                    </td>
                                    {/* date & time */}
                                    <td>
                                      <div className="d-flex px-2 py-1">
                                        <div className="d-flex flex-column justify-content-center">
                                          <h6 className="text-sm mb-2">
                                            <span className="text-dark font-weight-bold ms-sm-2">
                                              status : {item?.schedule_status}
                                            </span>
                                          </h6>
                                          <p className="text-xs mb-2">
                                            <span className="text-dark font-weight-bold ms-sm-2">
                                              {item?.date}
                                            </span>
                                          </p>
                                          <p className="text-xs mb-2">
                                            <span className="text-dark font-weight-bold ms-sm-2">
                                              {item.time}
                                            </span>
                                          </p>
                                        </div>
                                      </div>
                                    </td>
                                    {/* Products */}
                                    <td>
                                      <div className="d-flex px-2 py-1">
                                        <div className="d-flex flex-column justify-content-center">
                                          <p className="text-xs mb-2">
                                            Name&nbsp;:&nbsp;
                                            <span className="text-secondary">
                                              {item?.product_id?.name}
                                            </span>
                                          </p>
                                          <img
                                            src={
                                              config?.fileurl +
                                              item?.product_id?.image?.[0]
                                                ?.filename
                                            }
                                            alt="img"
                                            width={40}
                                            height={40}
                                          />
                                          <p
                                            className="text-xs"
                                            style={{ paddingBlockStart: 8 }}
                                          >
                                            SKUID&nbsp;:&nbsp;
                                            <span className="text-secondary">
                                              {item?.product_id?.skuid}
                                            </span>
                                          </p>
                                        </div>
                                      </div>
                                    </td>
                                    {/* Action */}
                                    <td>
                                      <div className="ms-auto">
                                        <a
                                          href={'/appointment/web/' + item._id}
                                          className="btn btn-link text-dark px-3 mb-0"
                                        >
                                          <i
                                            className="fa fa-eye text-dark me-2"
                                            aria-hidden="true"
                                          ></i>
                                          View
                                        </a>
                                      </div>
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <>
                                  <tr>
                                    <th
                                      className="text-secondary opacity-7 text-center"
                                      colspan="5"
                                    >
                                      <p>Data not found</p>
                                    </th>
                                  </tr>
                                </>
                              )}
                            </tbody>
                          </table>
                        </div>
                        <div className="col-12 paginationWrapper">
                          {/* Pagination */}
                          {webApptTotalResult < 11 ? (
                            <></>
                          ) : (
                            <section className={'paginationWrapper'}>
                              <section>
                                <Typography variant="body1">
                                  Page {webApptCurrentPage} of{' '}
                                  {Math.ceil(
                                    webApptTotalResult / webApptParams.limit
                                  )}
                                </Typography>
                              </section>
                              <Pagination
                                count={Math.ceil(
                                  webApptTotalResult / webApptParams.limit
                                )}
                                page={webApptCurrentPage}
                                onChange={handleWebApptPagination}
                                color="primary"
                                shape="rounded"
                              />
                            </section>
                          )}
                        </div>
                      </div>
                    </Tab>
                  </Tabs>
                </section>
              </div>
            </div>
          </div>
        </div>
      </main>      
      <ToastContainer />
    </>
  )
}

export default Appointments
